/**
 * Platform Upload Hook
 * Thin wrapper around core upload hook for platform datadrive
 */

import { PlatformFSContext } from './core/context'
import { FILE_STATUS, UPLOAD_RESPONSE_CODE, useUploadCore } from './core/hooks/useUpload'

// Re-export types and enums for backward compatibility
export { FILE_STATUS, UPLOAD_RESPONSE_CODE }
export type { IUploadTask as ITask } from './core/hooks/useUpload'

// Singleton platform context
const platformContext = new PlatformFSContext()

/**
 * Platform upload hook
 * @returns Upload state and control functions
 */
export function useUpload() {
  return useUploadCore(platformContext)
}
